import { SelectFieldOption } from "@generation/core";

let zorgjarenDatasource: SelectFieldOption[] = [];

export const setZorgjarenOptions = (options: SelectFieldOption[]) => {
  zorgjarenDatasource = options;
};

export const getZorgjarenOptions = () => zorgjarenDatasource;
